import React from 'react';
import PropTypes from 'prop-types';
import Popup from './PopUp.component';
import Comment from '../input/Comment.component';
import EmailInput from '../input/EmailInput.component';
import ErrorDialog from './ErrorDialog.component';
import * as Api from '../../utils/api/api.js';
import translate from '../translations/translations.wrapper.jsx';
import {TASK_ACTIONS} from "utils/constants.js";
import './emailPopup.scss';
import {Notification, NotificationType} from "components/common/Notification.component";
import Checkbox from "components/common/checkbox.component";
import { Button, ButtonType } from "components/common/Button.component";
import { FormField } from "components/common/FormField.component";
import { TextInput } from "components/common/TextInput.component";

//this is to make sure the tabbing stays inside the dialog
const TAB_INDEX = 1000;

export class Email extends Popup {
    constructor(props) {
        super(props);
        this.toInputRef = React.createRef();
        this.ok = this.ok.bind(this);
        this.buildContent = this.buildContent.bind(this);
        this.focusFirst = this.focusFirst.bind(this);

        const firstTask = props.tasks[0];
        let fromField = " " + this.props.translate("popUp.email.from") + " " + (firstTask.supplierName ? firstTask.supplierName : firstTask.requesterName);
        //let subject = this.props.translate("documentType." + DOCUMENT_TYPE.asString(firstTask.documentType)) + " - " + (firstTask.displayId ? firstTask.displayId : "") + (fromField ? fromField : "");
        let subject = fromField ? fromField + " : " + firstTask.description : firstTask.description;

        this.state = {
            to: '',
            cc: '',
            bcc: '',
            subject: subject,
            sendAttachment: true,
            sendCopy: true,
            comment: '',
            actionRunning: false,
            displayError: null,
            showCcInput: false,
            showBccInput: false
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.focusFirst();
    }

    focusFirst() {
        if (this.toInputRef.current) {
            this.toInputRef.current.focus();
        }
    }

    ok() {
        if (this.state.to && this.state.comment) {
            this.setState({actionRunning: true});

            const key = this.props.tasks[0].key;
            const self = this;

            let toCall = this.props.sendDocument ? Api.emailDocument : Api.emailTask;

            toCall(key,
                this.state.to, this.state.comment, this.state.subject,
                this.state.sendAttachment, this.state.sendCopy, this.state.cc, this.state.bcc,
                this.props.companyId
            ).then(function (response) {
                    self.props.showNotification(response.message);
                    self.props.closeCallback();
                },
                function (error) {
                    self.setState({displayError: error});
                }
            );

        }
    }

    buildContent() {

        const okEnabled = !this.state.actionRunning && this.state.to && this.state.comment;
        const ccButtonsVisible = !this.state.showCcInput || !this.state.showBccInput;
        let myEmail = this.props.loggedInData ? this.props.loggedInData.emailAddress : "";
        return (
            <div>
                {this.state.displayError && <ErrorDialog
                    error={this.state.displayError}
                    closeCallback={() => this.setState({actionRunning: false, displayError: null})}
                    translate={this.props.translate}
                />}
                <div className="panel-body email-dialog">
                    <div className="my-3"><Notification type={NotificationType.INFORMATION}
                                                        description={this.props.translate("popUp.email.placeholder")}/>
                    </div>

                    <div className="row w-100 m-0 p-0">
                        <div className={ccButtonsVisible ? "col-md-9 p-0" : "col-md-12 p-0"}>
                            <FormField
                                id="to"
                                label={this.props.translate("popUp.email.to")}
                                labelState={`(${this.props.translate("popUp.required")})`}>
                                <EmailInput
                                    ref={this.toInputRef}
                                    className="w-100 p-0 position-relative"
                                    thisId="to"
                                    tabIndex={TAB_INDEX+1}
                                    autoFocus={true}
                                    propagateValue={(value) => this.setState({to: value})}
                                    translate={this.props.translate}
                                    value={this.state.to}
                                />
                            </FormField>
                        </div>
                        {ccButtonsVisible &&
                            <div className="col-md-3 p-0 text-end mb-16 align-self-end d-flex gap-8 justify-content-end">
                                {!this.state.showCcInput &&
                                    <Button type={ButtonType.SECONDARY}
                                            tabIndex={TAB_INDEX + 2}
                                            onClick={() => {
                                                this.setState({showCcInput: true})
                                            }}
                                            text={this.props.translate("popUp.email.cc")}
                                    />
                                }
                                {!this.state.showBccInput &&
                                    <Button type={ButtonType.SECONDARY}
                                            tabIndex={TAB_INDEX + 3}
                                            onClick={() => {
                                                this.setState({showBccInput: true})
                                            }}
                                            text={this.props.translate("popUp.email.bcc")}
                                    />
                                }
                            </div>
                        }

                    </div>

                    {this.state.showCcInput &&
                        <FormField
                            id="cc"
                            label={this.props.translate("popUp.email.cc")}>
                            <EmailInput className="w-100 p-0 position-relative" thisId="cc"
                                        propagateValue={(value) => this.setState({cc: value})}
                                        value={this.state.cc}
                                        translate={this.props.translate}
                                        tabIndex={TAB_INDEX + 4}
                            />
                        </FormField>
                    }

                    {this.state.showBccInput &&
                        <FormField
                            id="bcc"
                            label={this.props.translate("popUp.email.bcc")}>
                            <EmailInput className="w-100 p-0 position-relative" thisId="bcc"
                                        propagateValue={(value) => this.setState({bcc: value})}
                                        value={this.state.bcc}
                                        translate={this.props.translate}
                                        tabIndex={TAB_INDEX + 5}/>
                        </FormField>
                    }

                    <FormField
                        id="subject"
                        label={this.props.translate("popUp.email.subject")}
                        labelState={`(${this.props.translate("popUp.required")})`}>
                        <TextInput
                            value={this.state.subject}
                            placeholder={this.props.translate("popUp.email.subjectPlaceholder")}
                            onChange={e => this.setState({subject: e.target.value})}
                            tabIndex={TAB_INDEX + 6}
                        />
                    </FormField>


                    <Comment
                        inputHint={this.props.translate("popUp.email.messagePlaceholder")}
                        inputLimit={0} // without limit
                        translate={this.props.translate}
                        tabIndex={TAB_INDEX + 7}
                        id="comment"
                        hideInitialValue={true}
                        propagateValue={value => this.setState({comment: value})}
                        label={this.props.translate("popUp.email.commentLabel")}
                        labelState={`(${this.props.translate("popUp.required")})`}
                    />

                    <Checkbox
                        inputId={"attachDoc"}
                        onChange={event => {
                            event.stopPropagation();
                            this.setState({sendAttachment: event.currentTarget.querySelector("input").checked})
                        }
                        }
                        tabIndex={TAB_INDEX + 8}
                        isChecked={this.state.sendAttachment}
                        ariaLabel={this.props.translate("popUp.email.attachDocument")}
                        label={this.props.translate("popUp.email.attachDocument")}
                    />


                    <Checkbox
                        inputId={"sendCopy"}
                        onChange={event => {
                            event.stopPropagation();
                            this.setState({sendCopy: event.currentTarget.querySelector("input").checked})
                        }}
                        tabIndex={TAB_INDEX + 9}
                        isChecked={this.state.sendCopy}
                        ariaLabel={this.props.translate("popUp.email.sendMeCopy", myEmail)}
                        label={this.props.translate("popUp.email.sendMeCopy", myEmail)}
                    />

                </div>
                <div className="modal-footer">
                    <div className="d-flex gap-8 float-right">
                        <Button type={ButtonType.PRIMARY}
                                onClick={this.ok}
                                disabled={!okEnabled}
                                tabIndex={TAB_INDEX + 10}
                                text={this.props.translate("popUp.email.send")}
                        />
                        <Button type={ButtonType.SECONDARY}
                                onClick={this.props.closeCallback}
                                onBlur={this.focusFirst}
                                tabIndex={TAB_INDEX + 11}
                                text={this.props.translate("popUp.cancel")}
                        />
                    </div>
                </div>
            </div>
        );
    }

    getType() {
        return TASK_ACTIONS.EMAIL;
    }
}

const withTranslations = translate(Email);
export default withTranslations;

Email.propTypes = {
    tasks: PropTypes.array, // selected tasks
    closeCallback: PropTypes.func, //callback for closing the popup
    translate: PropTypes.func, // to translate texts
    showNotification: PropTypes.func, // to show transient notification
};